import { ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';
import { provideRouter, Routes } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  withFetch
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';
import { AppSettings } from './app.settings';
import { ConfigService } from './services/domain/config.service';
import { UtilService } from './services/domain/util.service';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { PDFJS_LICENSE_TOKEN, SeedDesignSystemModule } from '@aionzdev/design-system';

registerLocaleData(localeBr, 'pt');

const DEFAULT_PDFJS_LICENSE = 'EdFyE4N4uwLN2pix8FNK';

const routes: Routes = [
  { path: 'docs', loadChildren: () => import('./pages/docs/docs.module').then(m => m.DocsModule) }
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    AppSettings,
    ConfigService,
    UtilService,
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: PDFJS_LICENSE_TOKEN, useValue: DEFAULT_PDFJS_LICENSE },
    SeedDesignSystemModule,
    ReactiveFormsModule,
    DragDropModule
  ]
};
